<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.contractCode')">
              <j-input :placeholder="$t('label.pleaseEnterTheContractCode')" v-model="queryParam.conCode"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="批次编码">
              <j-input placeholder="请输入批次编码" v-model="queryParam.breedBatchCode"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
             <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <a-button v-show=false type="primary" icon="download" @click="handleExportXls('合同价格清单')">{{$t('button.export')}}</a-button>
      <a-upload v-show=false name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type:'radio'}"
        :customRow="clickThenSelect"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider v-show=false type="vertical" />
          <a-dropdown v-show=false>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane :tab="$t('tabName.contractPriceListDetails')" key="1" >
        <EfsMdContractPriceListDetailList :mainId="selectedMainId" />
      </a-tab-pane>
    </a-tabs>

    <efsMdContractPriceList-modal ref="modalForm" @ok="modalFormOk"></efsMdContractPriceList-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdContractPriceListModal from './modules/EfsMdContractPriceListModal'
  import { getAction } from '@/api/manage'
  import EfsMdContractPriceListDetailList from './EfsMdContractPriceListDetailList'
  import {initDictOptions,filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import '@/assets/less/TableExpand.less'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: "EfsMdContractPriceListList",
    mixins:[JeecgListMixin],
    components: {
      JSearchSelectTag,
      EfsMdContractPriceListDetailList,
      EfsMdContractPriceListModal,
      JInput
    },
    data () {
      return {
        description: '合同价格清单管理页面',
        // 表头
        columns: [
          {
            slotName: 'tableHeader.contractCode',
            scopedSlots: { title: 'tableHeader.contractCode'},
            align:"center",
            dataIndex: 'conCode',
          },
          {
              slotName: 'tableHeader.contractName',
            scopedSlots: { title: 'tableHeader.contractName'},
              align:"center",
              dataIndex: 'conCode_dictText',
          },
          {
            slotName: 'tableHeader.batchCode',
            scopedSlots: { title: 'tableHeader.batchCode'},
            align:"center",
            dataIndex: 'breedBatchCode',
          },
          {
              title:'批次名称',
              align:"center",
              dataIndex: 'breedBatchCode_dictText',
          },
          // {
          //   title:'是否有效',
          //   align:"center",
          //   dataIndex: 'validFlag_dictText',
          // },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align:"center",
          //   fixed:"right",
          //   width:147,
          //   scopedSlots: { customRender: 'action' },
          // }
        ],
        url: {
          list: "/contractPriceList/efsMdContractPriceList/list",
          delete: "/contractPriceList/efsMdContractPriceList/delete",
          deleteBatch: "/contractPriceList/efsMdContractPriceList/deleteBatch",
          exportXlsUrl: "/contractPriceList/efsMdContractPriceList/exportXls",
          importExcelUrl: "contractPriceList/efsMdContractPriceList/importExcel",
        },
        dictOptions:{
         validFlag:[],
        },
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 5,
          pageSizeOptions: ['5', '10', '50'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        selectedMainId:''

      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
        initDictOptions('efs_md_contract,name,code').then((res) => {
          if (res.success) {
            this.$set(this.dictOptions, 'conCode', res.result)
          }
        })
        initDictOptions('efs_md_breed_batch,name,code').then((res) => {
          if (res.success) {
            this.$set(this.dictOptions, 'breedBatchCode', res.result)
          }
        })
        initDictOptions('sfyx').then((res) => {
          if (res.success) {
            this.$set(this.dictOptions, 'validFlag', res.result)
          }
        })
      },
      clickThenSelect(record) {
        return {
          on: {
            click: () => {
              this.onSelectChange(record.id.split(","), [record]);
            }
          }
        }
      },
      onClearSelected() {
        this.selectedRowKeys = [];
        this.selectionRows = [];
        this.selectedMainId=''
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedMainId=selectedRowKeys[0]
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
      },
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t('tip.pleaseSet') + "url.list属性!")
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        this.onClearSelected()
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>